export default __webpack_public_path__ + "static/media/apps-settings.f945a3b1.svg";